import { Component, OnInit, Renderer2 } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { GlobalService } from "../../services/global.service";
import { NgxSpinnerService } from "ngx-spinner";
import Swal from "sweetalert2";
const Excel = require("exceljs");
import { DatePipe } from "@angular/common";
import Math from "exact-math";
import * as SecureLS from "secure-ls";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { CommonService } from "src/app/services/common.service";
import { StorageService } from "../../services/storage.service";

@Component({
  selector: "app-audio-device",
  templateUrl: "./audio-device.component.html",

  styleUrls: ["./audio-device.component.css"],
})
export class AudioDeviceComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  roleID = this.storageService.getRole();
  userID = this.ls.get("createdBy");
  page: number = 1;
  page_size: number = 10;
  alphaPattern = "[a-zA-Z .,]*";
  active = 1;
  AudioDeviceForm: FormGroup;
  showLoadMore = false;
  submitted = false;
  ippattern =
    "(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)";
  manualUpdate = true;
  swal: any;
  enable = true;
  total_count = 0;
  audcreate: any;
  audiodeviceList: any[];
  getaudio: any;
  editaudio: any;
  is_active = false;
  deleteaudio: any;
  editstatus = false;
  audupdate: any;
  audstatusupdate: any;
  editid: any;
  editbut: boolean;
  isactiveswitch: any;
  page_count = [];
  pageshow = true;
  htmlpageshow: boolean;
  audname: any;
  pagedItems: any[];
  total: number;
  p: number;
  writehide = false;
  writeaccess = this.ls.get("write_access");
  searchForm: FormGroup;
  filtervalues: boolean;
  chiparray: any = [];
  bulk_form: FormGroup;
  selectedFiles: any;
  view_File_name: any;
  bulkcreate: Object;
  entryFields: boolean = false;
  createNew: boolean = true;
  backendValidationErrors: null;

  constructor(
    private storageService: StorageService,
    private modalService: NgbModal,
    public router: Router,
    private fb: FormBuilder,
    public globalService: GlobalService,
    public fileupload: CommonService,
    private spinner: NgxSpinnerService,
    private renderer: Renderer2
  ) {}

  async ngOnInit() {
    this.searchForm = this.fb.group({
      id: [""],
      audioname: [""],
    });
    this.AudioDeviceForm = this.fb.group({
      id: [""],
      device_ip: ["", [Validators.required]],
      is_active: [""],
    });
    this.bulk_form = this.fb.group({
      bulk_file: [""],
    });

    this.page = 1;
    this.AudioDeviceForm.valueChanges.subscribe((data)=>{
      this.backendValidationErrors = null;
    });
    if (this.ls.get("write_access") == 0) {
      this.writehide = true;
    }
    await this.getAudioDevice();
    await this.getPage(this.page, true);
  }

  openField() {
    this.entryFields = true;
    this.createNew = false;
    this.AudioDeviceForm.reset();
    this.submitted = false;
  }

  cancelFields(isEditbut?) {
    this.renderer.removeClass(document.body, "modal-open");
    this.entryFields = false;
    this.AudioDeviceForm.reset();
    this.createNew = true;
    if (isEditbut) {
      this.editbut = false;
    }
  }

  async getPage(page: number, disableCall: boolean) {
    this.spinner.show();
    this.page = page;
    if(!disableCall) {
    await this.getAudioDevice();
    }
    const res = await this.serverCall(this.audiodeviceList, page);
    this.total = this.total_count;
    this.p = page;

    this.pagedItems = res;
    this.spinner.hide();
  }

  async serverCall(sample: any[], page: number) {
    const perPage = this.page_size;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }
  get forms() {
    return this.AudioDeviceForm.controls;
  }
  get forms1() {
    return this.searchForm.controls;
  }

  async createAudioDevice(form: FormGroup) {
    this.submitted = true;

    if (this.AudioDeviceForm.invalid) {
      return;
    }
    this.spinner.show();

    if (form.value.device_ip.trim() == "") {
      Swal.fire("warning!", "Please Provide Valid Device Name", "warning");
    } else {
      const inputData = {
        user_id: this.ls.get("createdBy"),
        vendor_id: this.ls.get("vendor_id"),
        device_name: form.value.device_ip,

        is_active: this.isactiveswitch
          ? this.isactiveswitch == true
            ? "1"
            : "0"
          : "0",
      };

      this.audcreate = await this.globalService.create(
        "audiodevice/create",
        inputData
      );

      if (this.audcreate["status"] === 200) {
        Swal.fire("Success!", this.audcreate["message"], "success");

        this.pageshow = true;
        this.getAudioDevice();
        this.reset();
        this.entryFields = false;
        this.createNew = true;
        this.backendValidationErrors = null;
        this.renderer.removeClass(document.body, 'modal-open');
      } else if (this.audcreate["status"] === 422) {
        this.backendValidationErrors = this.audcreate?.error["content"];
      } else {
        this.cancelFields();
        this.backendValidationErrors = null;
      }
    }
    this.spinner.hide();
  }
  switch(e) {
    this.isactiveswitch = e;
  }

  getAudioDevice() {
    this.spinner.show();
    if (this.page === 1) {
      this.audiodeviceList = [];
    }

    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      page: this.page,
      role_id: this.storageService.getRole(),
      device_name: this.audname,
      page_size: this.page_size,
    };

    this.globalService.get("audiodevice/list", filter).then((data) => {
      this.getaudio = data;
      this.spinner.hide();

      if (this.getaudio["status"] === 200) {
        this.total_count = this.getaudio["content"].count;       
        if (this.getaudio["content"]["rows"].length < this.page_size) {
          this.showLoadMore = true;
        }
        this.audiodeviceList = this.getaudio["content"]["rows"];
        if (this.pageshow === true) {
          this.page_count = [];
          let page_count = Math.ceil(this.total_count / this.page_size);
          if (page_count > 1) {
            this.htmlpageshow = true;
          } else {
            this.htmlpageshow = false;
          }
        }
      } else {
        this.htmlpageshow = false;
        this.showLoadMore = true;
        this.spinner.hide();
      }
    });
  }
  editAudioDevice(id, device_ip, device_type) {
    this.spinner.show();
    Swal.fire({
      title: "Edit ?",
      text: "Are you sure you want to edit this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        this.spinner.show();
        this.openField();
        this.active = 2;
        this.editbut = true;
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id,
          device_name: device_ip,
        };

        this.editaudio = await this.globalService.get(
          "audiodevice/get",
          filter
        );
        let comp_details = this.editaudio["content"];

        if (this.editaudio["status"] === 200) {
          this.AudioDeviceForm.controls["id"].setValue(comp_details.id);
          this.AudioDeviceForm.controls["device_ip"].setValue(
            comp_details.device_name
          );

          this.editid = comp_details.id;
          this.editstatus = comp_details.is_active;
        }
        this.spinner.hide();
      } else {
        this.cancelFields();
      }
    });
    this.spinner.hide();
  }
  reset() {
    this.submitted = false;
    this.AudioDeviceForm.reset();
    this.editstatus = false;
    this.isactiveswitch = false;
  }

  loadMore(index) {
    this.pageshow = true;
    this.page = index;
    this.getAudioDevice();
  }
  previous() {
    this.pageshow = true;
    this.page = this.page - 1;
    this.getAudioDevice();
  }
  next() {
    this.pageshow = true;
    this.page = this.page + 1;
    this.getAudioDevice();
  }
  openScrollableContent(longContent) {
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
    }
  }
  selectFile(event) {
    this.selectedFiles = event.target.files;
    this.view_File_name = this.selectedFiles.item(0).name;
  }

  async BulkUpload(form: FormGroup) {
    if (
      form.value.bulk_file === null ||
      form.value.bulk_file === undefined ||
      form.value.bulk_file === ""
    ) {
      Swal.fire("", "Please upload the file", "error");
    }
    let dataExport = [];
    let file;
    let files;

    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(this.selectedFiles[0]);
    if (this.selectedFiles != null) {
      const file = this.selectedFiles.item(0);
      if (
        file.type !== "application/vnd.ms-excel" &&
        file.type !==
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
        file.type !== "application/vnd.oasis.opendocument.spreadsheet"
      ) {
        this.spinner.hide();
        Swal.fire("Error!", "Only Excel files are allowed", "error");
        return;
      }
      if (
        file.type !== "application/vnd.ms-excel" &&
        file.type !==
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
        file.type !== "application/vnd.oasis.opendocument.spreadsheet"
      ) {
        this.spinner.hide();
        Swal.fire("Error!", "Only Excel files are allowed", "error");
        return;
      }

      if (file.size > 2097152) {
        Swal.fire("warning!", "File Size Must be under 2 MB", "warning");
        return false;
      }
      if (
        file.type == "application/vnd.ms-excel" ||
        file.type ==
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type == "application/vnd.oasis.opendocument.spreadsheet"
      ) {
        let formdata = new FormData();
        formdata.append("file", file);
        formdata.append("user_id", this.ls.get("createdBy"));
        formdata.append("vendor_id", this.ls.get("vendor_id"));
        formdata.append("upload_role_id", "4");
        formdata.append("role_id", String(this.storageService.getRole()));
        formdata.append("requester_type", "web");

        this.spinner.show();
        reader.onload = async (e: any) => {
          /* create workbook */ const binarystr: string = e.target.result;
          const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: "binary" });

          /* selected the first sheet */ const wsname: string =
            wb.SheetNames[0];
          const ws: XLSX.WorkSheet = wb.Sheets[wsname];
          /* save data */ //const data = XLSX.utils.sheet_to_json(ws); // to get 2d array pass 2nd parameter as object {header: 1};

          const data = XLSX.utils.sheet_to_json(ws);

          if (data.length > 100) {
            this.spinner.hide();
            Swal.fire(
              "Warning!",
              "Records more than 100 not be allowed",
              "warning"
            );

            return;
          } else {
            this.bulkcreate = await this.globalService.update(
              "audiodevice/upload/excel",
              formdata
            );

            if (this.bulkcreate["status"] === 200) {
              let bulk = this.bulkcreate["content"];
              const expectedHeaders = ["device_name"];
              const missingDataRows = bulk.filter((row) => {
                return expectedHeaders.some((header) => !row[header]);
              });
              if (missingDataRows.length > 0) {
                Swal.fire(
                  "Warning!",
                  "Some rows are missing data for required headers. Please check the file.",
                  "warning"
                );
              } else {
                for (let i = 0; i < bulk.length; i++) {
                  dataExport.push({
                    Sno: i + 1,
                    device_name: bulk[i].device_name,
                    message: bulk[i].message,
                  });
                }

                var a = await this.fileupload.exportExcel(
                  dataExport,
                  "Audio Device List"
                );
                Swal.fire("Success!", this.bulkcreate["message"], "success");
                this.getAudioDevice();
                this.pageshow = true;
                this.bulk_form.reset();
              }
            }
            this.spinner.hide();
            this.cancelFields();
          }
        };
      }
    }
  }

  Filter(audname) {
    this.filtervalues = true;
    this.chiparray = [];
    if (this.audname != undefined && this.audname != "") {
      this.chiparray.push("AudioDevice  Name :" + " " + this.audname);
    }

    this.audname = audname;
    this.pageshow = true;
    this.page = 1;
    this.getAudioDevice();
  }
  res() {
    this.filtervalues = false;
    this.audname = null;
    this.searchForm.reset();
    this.pageshow = true;
    this.page = 1;
    this.getAudioDevice();
  }
  AudioDeviceStatusUpdate(value: boolean, id) {
    this.spinner.show();
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to Change Status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let status;
        this.manualUpdate = value;
        if (value == false) {
          status = "0";
        } else if (value == true) {
          status = 1;
        }
        const inputData = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id ? id : this.editid,
          is_active: status,
        };
        this.audstatusupdate = await this.globalService.update(
          "audiodevice/update/status",
          inputData
        );

        if (this.audstatusupdate["status"] === 200) {
          Swal.fire("Success!", this.audstatusupdate["message"], "success");
          this.pageshow = true;
          this.getAudioDevice();
        }
        if (this.audstatusupdate["status"] != 200) {
          this.pageshow = true;
          this.getAudioDevice();
        }
        this.is_active = status;
      } else {
        this.pageshow = true;
        this.getAudioDevice();
      }
    });
    this.spinner.hide();
  }

  async updateAudioDevice(form: FormGroup) {
    this.submitted = true;

    if (this.AudioDeviceForm.invalid) {
      return;
    }
    this.spinner.show();
    if (form.value.device_ip.trim() == "") {
      Swal.fire("warning!", "Please Provide Valid Device Name", "warning");
    } else {
      const inputData = {
        id: form.value.id,
        vendor_id: this.ls.get("vendor_id"),
        is_active: this.is_active ? this.is_active : this.editstatus,
        user_id: this.ls.get("createdBy"),
        device_name: form.value.device_ip,
      };

      this.audupdate = await this.globalService.update(
        "audiodevice/update",
        inputData
      );

      if (this.audupdate["status"] === 200) {
        Swal.fire("Success!", this.audupdate["message"], "success");

        this.editbut = false;
        this.pageshow = true;
        this.getAudioDevice();
        this.reset();
        this.entryFields = false;
        this.createNew = true;
        this.backendValidationErrors = null;
        this.renderer.removeClass(document.body, 'modal-open');
      } else if (this.audupdate["status"] === 422) {
        this.backendValidationErrors = this.audupdate?.error["content"];
      } else {
        this.cancelFields();
        this.backendValidationErrors = null;
      }
    }
    this.spinner.hide();
  }
  async downloadSampleTemplate() {
    const workbook = new Excel.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");
    worksheet.getCell("A1").value = "Sno";
    worksheet.getCell("B1").value = "device_name";

    worksheet.getCell("A2").value = "1";
    worksheet.getCell("B2").value = "Audio123";

    for (let i = 2; i < 2500; i++) {
      worksheet.getCell(`D${i}`).dataValidation = {
        type: "list",
        allowBlank: true,
        showInputMessage: false,
        formulae: ["$J$1:$J$1048576"],
      };
    }

    worksheet.getColumn(1).width = 20;
    worksheet.getColumn(2).width = 20;
    worksheet.getColumn(3).width = 20;
    worksheet.getColumn(4).width = 20;
    worksheet.getColumn(5).width = 20;
    worksheet.getColumn(6).width = 20;

    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, "Audio Device Sample List" + ".xlsx");
    });
  }

  async deleteAudioDevice(id, device_ip) {
    this.spinner.show();
    Swal.fire({
      title: "Delete ?",
      text: "Are you sure you want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        this.active = 2;
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id,
          device_name: device_ip,
        };
        this.deleteaudio = await this.globalService.delete(
          "audiodevice/delete",
          filter
        );
        if (this.deleteaudio["status"] === 200) {
          this.audiodeviceList = [];
          Swal.fire("Success!", this.deleteaudio["message"], "success");
          this.pageshow = true;
          this.getAudioDevice();
        }
      }
    });
    this.spinner.hide();
  }

  resetbulk() {
    this.bulk_form.reset();
  }

  formAddReset() {
    this.AudioDeviceForm.reset();
    this.editbut = false;
    this.bulk_form.reset();
  }
  formUpdateReset() {
    this.AudioDeviceForm.controls["id"].setValue(this.editaudio["content"].id);
    this.AudioDeviceForm.controls["device_ip"].setValue(
      this.editaudio["content"].device_name
    );
    this.AudioDeviceForm.reset();
    this.AudioDeviceForm.get("id").setValue(this.editaudio["content"].id);
  }

  onActiveTab(active) {
    if (active !== 1) {
      this.bulk_form.controls["bulk_file"].patchValue("");
    }
  }

  paginationCount(value) {
    this.page = 1;
    if (value >= 5) {
      this.page_size = value;
    }
    this.getAudioDevice();
  }
}
